import React from "react";
import "../Dashboard.scss";

const NoAvailableData = ({ message = "No data available for this chart", icon = "empty" }) => {
  return (
    <div className="no-data-container">
      <div className="no-data-content">
        <div className="no-data-icon">
          <img 
            src={require(`styles/images/icons/empty.svg`)} 
            alt="No data" 
            className="no-data-image" 
          />
        </div>
        <p className="no-data-message">{message}</p>
      </div>
    </div>
  );
};

export default NoAvailableData;